
	import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
	import BaseVue from '@/components/BaseVue'
	import appBar from '@/components/AppBar.vue'
	import { EditCondition } from '../models/EmpPasswordCondition'
    import { Authority } from '../models/Authority'
	import { MonthlyData } from '../models/MonthlyData'
	import { TrainPassData } from '../models/TrainPassData'
    import { LogData } from '../models/LogData'
    import { Const } from '../scripts/Const'
    import { MsgConst } from '../scripts/MsgConst'
    import { StringUtil } from '../scripts/StringUtil'
    import { RouteItem, LowestInfo} from '../models/RouteItem'
    import { TrainPassApplicationSearchCondition } from '../models/TrainPassApplicationSearchCondition'
    import { StationInput } from '../models/StationInput';
    import StationTextField from '@/components/StationTextField.vue';
    import MoneyTextField from '@/components/MoneyTextField.vue';
    import { TrainPassRouteSearchCondition } from '../models/EkitanSearchCondition';
    import ControlManager from '../scripts/ControlManager';
    import { search1stStation, searchRouteForTrainPass, searchLowestForPass } from '../scripts/SearchEkitan'
    import * as holiday_jp from '@holiday-jp/holiday_jp';
@Component({
    components: { appBar, StationTextField, MoneyTextField}
})
export default class TrainPassApplicationView extends BaseVue {
	//#region 変数

	private authority: Authority = new Authority()
    private logs: LogData[] = []
	private isPreviousSame = false
	private isTrainPass = true
	private passRoute2 = false
    private passRoute3 = false
    private menu = false
	private eventNm = ''
	private showPassword = false
	private monthlyData: MonthlyData = new MonthlyData()
    private editCondition: TrainPassData = new TrainPassData()
    private lastInfo: TrainPassData = new TrainPassData()
    private lastMonthInfo: TrainPassData = new TrainPassData()
    private searchCondition: TrainPassApplicationSearchCondition = new TrainPassApplicationSearchCondition()
    private routes1: RouteItem[] = []
    private routes2: RouteItem[] = []
    private routes3: RouteItem[] = []
    private notLowest1Flg: boolean = false;
    private notLowest2Flg: boolean = false;
    private notLowest3Flg: boolean = false;
    private ymStr: string;

    //#region @Ref
    @Ref('trainPassSaveBtn')saveBtn!: Vue;
    @Ref('trainPassCancelBtn')cancelBtn!: Vue;
    @Ref('trainPassConfirmBtn')confirmBtn!: Vue;
    @Ref('trainPassApprovalBtn')approvalBtn!: Vue;
    @Ref('trainPassRejectBtn')rejectBtn!: Vue;
    @Ref('trainPassCloseMonthlyBtn')closeMonthlyBtn!: Vue;
    @Ref('trainPassCancelCloseBtn')cancelCloseBtn!: Vue;
    @Ref('trainPassSearch1Btn')search1Btn!: Vue;
    @Ref('trainPassSearch2Btn')search2Btn!: Vue;
    @Ref('trainPassSearch3Btn')search3Btn!: Vue;
    @Ref('trainPassSameLastMonthCheck')sameLastMonthCheck!: Vue;
    @Ref('trainPassSameLastCheck')sameLastCheck!: Vue;
    @Ref('trainPassPurchaseCheck')purchaseCheck!: Vue;
    @Ref('trainPassYm')ym!: Vue;
    //#endregion

    //コントロールごとの活性制御
    private controlManager = new ControlManager();
	//#region 最新駅検索条件
	private lastStartStation1: StationInput = {
        text: '',
        cd: '',
	};
	private lastEndStation1: StationInput = {
        text: '',
        cd: '',
    };
    private lastTransitStation1: StationInput = {
        text: '',
        cd: '',
	};
    private lastStartStation2: StationInput = {
        text: '',
        cd: '',
    };
    private lastEndStation2: StationInput = {
        text: '',
        cd: '',
    };
    private lastTransitStation2: StationInput = {
        text: '',
        cd: '',
	};
    private lastStartStation3: StationInput = {
        text: '',
        cd: '',
    };
    private lastEndStation3: StationInput = {
        text: '',
        cd: '',
    };
    private lastTransitStation3: StationInput = {
        text: '',
        cd: '',
	};

	//#endregion

	private addPassRoute2 = false
    private addPassRoute3 = false

    //#region 最安値
    private lowestInfo1: LowestInfo = new LowestInfo();
    private lowestInfo2: LowestInfo = new LowestInfo();
    private lowestInfo3: LowestInfo = new LowestInfo();
    //#endregion

	//#region メッセージ
	private showMessage = false
	private messageType = 'info'
	private message = ''
	//#endregion

    //#region ダイアログ
    private dialog = false
    private confirmationDialog = false
    private confirmationDialogResult: boolean
    private title = ''
    private dialogMsg = ''
	//#endregion

    //#region ガイダンス
    private showGuidance = false
    private guidanceType = 'info'
    private guidance = ''
	//#endregion

	//#region 表示制御

    //決済理由
    private showDecisionRemarks = false
    private showDecisionRemarksDialog = false	//管理職承認・否認時入力用

    //ボタン
    private showSavebtn         = false
    private showCancelbtn       = false
    private showConfirmbtn      = false
    private showApprovalbtn     = false
    private showRejectbtn       = false
    private showCloseMonthly    = false
    private showCancelClose     = false
	//#endregion

	//#region 活性制御
    private disableSavebtn      : boolean = false
    private disableCancelbtn    : boolean = false
    private disableConfirmbtn   : boolean = false
    private disableApprovalbtn  : boolean = false
    private disableRejectbtn    : boolean = false
    private disableCloseMonthly : boolean = false
    private disableCancelClose: boolean = false
	//#endregion

    //ログ
    private showLog = false

    //#region  ヘッダー
    private headers = [
        {
            text: '',
            value: 'check',
            width: '2%',
            class: 'primary sticky1 zindex4 nowRap sticky-header white--text',
            align: 'center',
            sortable: false,

        },
        {
            text: '経路',
            value: 'passInfo',
            width: '80%',
            class: 'primary sticky-header nowRap white--text',
            align: 'center',
            sortable: false,
        },
        {
            text: '所要時間',
            value: 'time',
            width: '7%',
            class: 'primary sticky-header nowRap white--text',
            align: 'center',
            sortable: false,
        },
        {
            text: '料金',
            value: 'exceptCommuterFare',
            width: '7%',
            class: 'primary sticky-header nowRap white--text',
            align: 'center',
            sortable: false,
        }
    ]
	//#endregion

	//#endregion

	//#region イベント

	//#region 初期表示イベント
    private async created() {

        this.initialize();

        this.searchCondition = new TrainPassApplicationSearchCondition()

        this.searchCondition.empCd = this.$route.params.empCd
        this.searchCondition.ym = this.$route.params.ym
        this.searchCondition.beforeViewName = this.$route.params.beforeViewName
        this.searchCondition.beforeViewParam1 = this.$route.params.beforeViewParam1
        this.searchCondition.beforeViewParam2 = this.$route.params.beforeViewParam2
        this.searchCondition.beforeViewParam3 = this.$route.params.beforeViewParam3

        this.editCondition = new TrainPassData()

        //定期申請情報の取得
        this.getTrainPassData();

        //活性制御
        this.displayDisableContorol()
        //表示制御
        this.displayShowControl()
        //ガイダンスを表示する
        this.getGuidance(this.editCondition.requestStatus)
        //登録経路を選択する
        Promise.all([this.selectRoute(1), this.selectRoute(2), this.selectRoute(3)]);
		//画面上部へスクロール
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

    //#region　検索ボタン押下（経路）
    private async clickSearchRoute(no: number) {
        try {

            //駅名入力値をチェックする
            let resultValid: boolean = false;

            resultValid = await this.isValidForSearchRoute(no);

            if (resultValid) {
                //経路を検索する

                //項目初期化
                this.clearRouteContent(no);

                //検索
                this.searchRoute(no);               
            }
        }
        catch (e) {
            console.log(e.message)
        } finally {
        }
    }
    //#endregion

    //#region 登録ボタン押下
    private clickEdit() {

        let messageStr: string
        messageStr = ''

        if (this.passRoute2 && !this.editCondition.passKey2) {
            messageStr += '経路2'
        }

        if (this.passRoute3 && !this.editCondition.passKey3) {
            if (messageStr) { messageStr += ',' }

            messageStr += '経路3'
        }

        if (messageStr) {

            messageStr = StringUtil.stringFormat(MsgConst.TRAINPASS.CONFIRM_001, messageStr)

            //確認ダイアログ
            this.eventNm = 'checkEdit'
            this.openDialog('確認', messageStr)
        }
        else {
            this.eventNm = 'edit'
            this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_018, '定期申請情報'))
        }
    }
    //#endregion

    //#region 取消ボタン押下
    private clickCancel() {
        //確認ダイアログ
        this.eventNm = 'cancel'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_003, '定期申請情報'))
    }
    //#endregion

    //#region 確認ボタン押下
    private clickConfirm() {

        this.eventNm = 'confirm'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_004, '定期申請情報'))

    }
    //#endregion

    //#region 承認ボタン押下
    private clickApproval() {
        this.showDecisionRemarksDialog = true
        
        this.eventNm = 'approval'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_005, '定期申請情報'))

    }   
    //#endregion

    //#region 否認ボタン押下
    private clickReject() {
        this.showDecisionRemarksDialog = true

        this.eventNm = 'reject'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_006, '定期申請情報'))

    }
	//#endregion

    //#region 締めボタン押下
    private clickCloseMonthly() {
        this.eventNm = 'closeMonthly'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_007, '定期申請情報'))
    }
    //#endregion

    //#region 締め解除ボタン押下
    private clickCancelClosing() {
        this.eventNm = 'cancelClosing'
        this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_008, '定期申請情報'))
    }
    //#endregion

    //#region 定期購入チェックON
    private changePurchaseFlg() {
        if (this.editCondition.trainPassPurchaseFlg === true) {
            this.eventNm = 'changePurchaseFlg'
            this.openDialog('確認', MsgConst.TRAINPASS.CONFIRM_002)
        }
    }
    //#endregion

    //#region 経路２追加　変更
    private onRoute2Changed() {

        this.passRoute2 = !this.passRoute2

        if (this.passRoute2 === false) {

            this.eventNm = 'clickClearRoute2'
            this.openDialog('確認', MsgConst.TRAINPASS.CONFIRM_003)

        }
    }
    //#endregion

    //#region　経路３　変更
    private onRoute3Changed() {

        this.passRoute3 = !this.passRoute3

        if (this.passRoute3 === false) {

            this.eventNm = 'clickClearRoute3'
            this.openDialog('確認', MsgConst.TRAINPASS.CONFIRM_004)

        }
    }
    //#endregion

    //#region 前月と同じ　チェック変更
    private onChangeSameLastMonthFlg() {
        if (this.editCondition.sameLastMonthFlg === true) {
            this.eventNm = 'changeSameLastMonthFlg'
            this.openDialog('確認', MsgConst.TRAINPASS.CONFIRM_005)
        }
    }
    //#endregion

    //#region　前月経路と同じチェック変更
    private onChangeSameLastFlg() {
        if (this.editCondition.sameLastRouteFlg === true) {
            this.eventNm = 'changeSameLastFlg'
            this.openDialog('確認', MsgConst.TRAINPASS.CONFIRM_006)
        }
    }
    //#endregion

    //#region 年月変更
    private changeYm() {

        //初期化
        this.messageClear();
        //勤務表情報の取得
        this.searchCondition.ym = this.editCondition.ym.replace('-', '');
        this.searchCondition.empCd = this.editCondition.empCd;


        this.initialize();
        //勤務情報の取得
        this.getTrainPassData();
    }
    //#endregion

    //#region 経路選択
    private handleSpaceKey(no: number, item: RouteItem) {
        item.check = !item.check;
        this.onInputCheck(no, item);
    }

    private onInputCheck(no: number, item: RouteItem) {
        let checkedCount = 0

        for (const i of this[`routes${no}` as keyof TrainPassApplicationView]) {
            if (item.no != i.no) {
                i.check = false;
            } else {

                if (i.check) {
                    //金額と経路を登録条件に設定する
                    (this.editCondition[`passPrice${no}` as keyof TrainPassData] as string) = (i.exceptCommuterFare).toString();
                    (this.editCondition[`passKey${no}` as keyof TrainPassData] as string) = i.commuterRegistKey;
                    (this.editCondition[`trainPassInfo${no}` as keyof TrainPassData] as string) = i.passInfo;
                    checkedCount++;
                }
            }
        }

        if (checkedCount === 0) {
            (this.editCondition[`passPrice${no}` as keyof TrainPassData] as string) = '0';
            (this.editCondition[`passKey${no}` as keyof TrainPassData] as string) = '';
            (this.editCondition[`trainPassInfo${no}` as keyof TrainPassData] as string) = '';
        }
    }
    //#endregion

    //#region 戻るボタン押下
    private clickClose() {
        this.$store.commit('navigation/POP_HISTORY') // 現在画面を削除
        const previous = this.$store.getters['navigation/lastPage'] // ひとつ前を取得

        if (previous) {
            this.$router.push({
                name: previous.name,
                params: {
                    dateFrom: this.searchCondition.beforeViewParam1,
                    dateTo: this.searchCondition.beforeViewParam2,
                    searchString: this.searchCondition.beforeViewParam3,
                    workingYm: StringUtil.changeMonth(this.$route.params.ym, -1),
                    empCd: this.searchCondition.empCd,
                    beforeViewName: this.searchCondition.beforeViewName,
                    beforeViewParam1: this.searchCondition.beforeViewParam1,
                    beforeViewParam2: this.searchCondition.beforeViewParam2,
                    beforeViewParam3: this.searchCondition.beforeViewParam3,
                    isBack: true
                }as any
            })
        } else {
            this.$router.push({ name: 'Menu' })
        }
    }
	//#endregion

	//#endregion

	//#region プライベート
    //#region ガイダンスを表示する
    private getGuidance(requestStatus: string) {

        //何をすべきかガイダンスする
        this.showGuidance = false
        this.guidance = ''

        this.guidanceType = 'info'

        ////否認判定
        if (requestStatus === Const.TrainPassStatus.REMAND && this.showMessage === false) {
            this.guidanceType = 'error'
            this.guidance += MsgConst.COMMON.ERROR_001
            this.showGuidance = true
            return
        }

        //勤務表未登録判定
        if (this.editCondition.workingStatus === null && !this.authority.roleWorkingHoursAdmin) {
            this.guidanceType = 'error'
            this.guidance = MsgConst.COMMON.ERROR_002
            this.showGuidance = true
            return
        }

        if ((this.editCondition.workingStatus === Const.MonthlyStatus.APPROVED || this.editCondition.workingStatus === Const.MonthlyStatus.CLOSING) && !this.authority.roleWorkingHoursAdmin) {
            this.guidance = MsgConst.COMMON.ERROR_003
            this.showGuidance = true
            return
        }

        //作成中判定
        if (requestStatus === Const.TrainPassStatus.MAKING) {
            this.guidance += this.guidance != '' ? '・' : ''
            this.guidance += '定期申請'
            if (this.showApprovalbtn == true) {
                this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_007, this.guidance)
            } else {
                this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_008, this.guidance)
            }
            this.showGuidance = true
            return
        }

        //承認待ち判定
        if (requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {
                this.guidance += this.guidance != '' ? '・' : ''
                this.guidance += '定期申請'
            if (this.showApprovalbtn == true) {
                this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_001, this.guidance)
            } else {
                this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_002, this.guidance)
            }
            this.showGuidance = true
            return
        }

        //承認済み判定
        if (requestStatus === Const.TrainPassStatus.APPROVED) {
            this.guidance += this.guidance != '' ? '・' : ''
            this.guidance += '定期申請'
        }
        if (this.guidance != '') {
            this.guidance = MsgConst.COMMON.INFO_003
            this.showGuidance = true
            return
        }

        //締済み判定
        if (requestStatus === Const.TrainPassStatus.CLOSING && !this.authority.roleWorkingHoursAdmin) {
            this.guidance = MsgConst.COMMON.INFO_004
            this.showGuidance = true
            return
        }


    }
	//#endregion

	//#region　画面項目初期化
    private initialize() {

        this.editCondition = new TrainPassData();

        this.addPassRoute2 = false;
        this.addPassRoute3 = false;
        this.passRoute2 = false;
        this.passRoute3 = false;

        this.routes1 = [];
        this.routes2 = [];
        this.routes3 = [];

        this.notLowest1Flg = false;
        this.notLowest2Flg = false;
        this.notLowest3Flg = false;

        this.lowestInfo1 = { price: 0, passInfo: '', message:'' }
        this.lowestInfo2 = { price: 0, passInfo: '', message:'' }
        this.lowestInfo3 = { price: 0, passInfo: '', message:'' }

        this.showSavebtn        = false;
        this.showCancelbtn      = false;
        this.showConfirmbtn     = false;
        this.showApprovalbtn    = false;
        this.showRejectbtn      = false;
        this.showCloseMonthly    = false;
        this.showCancelClose     = false;
        this.showDecisionRemarks = false;


        this.lastStartStation1.cd = '';
        this.lastStartStation1.text = '';
        this.lastEndStation1.cd = '';
        this.lastEndStation1.text = '';
        this.lastTransitStation1.cd = '';
        this.lastTransitStation1.text = '';
        this.lastStartStation2.cd = '';
        this.lastStartStation2.text = '';
        this.lastEndStation2.cd = '';
        this.lastEndStation2.text = '';
        this.lastTransitStation2.cd = '';
        this.lastTransitStation2.text = '';
        this.lastStartStation3.cd = '';
        this.lastStartStation3.text = '';
        this.lastEndStation3.cd = '';
        this.lastEndStation3.text = '';
        this.lastTransitStation3.cd = '';
        this.lastTransitStation3.text = '';
	}
	//#endregion

    //#region 画面項目の表示制御
    private displayShowControl() {

        //処理前にすべて非表示状態にする
        this.showSavebtn         = false;
        this.showCancelbtn       = false;
        this.showConfirmbtn      = false;
        this.showApprovalbtn     = false;
        this.showRejectbtn       = false;
        this.showCloseMonthly    = false;
        this.showCancelClose     = false;
        this.showDecisionRemarks = false;

        //ログインユーザーまたは勤怠管理権限または管理職
        if (this.editCondition.empCd === this.authority.loginEmpCd || this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {

            //定期申請未登録
            if (this.editCondition.requestStatus === Const.TrainPassStatus.UNREGISTERED) {
                this.showSavebtn = true;
            }
            //定期申請作成中
            if (this.editCondition.requestStatus === Const.TrainPassStatus.MAKING) {
                this.showSavebtn = true;
            }
            //定期申請差戻
            if (this.editCondition.requestStatus === Const.TrainPassStatus.REMAND) {
                this.showSavebtn = true;
            }
        }

        //（＜＞ログインユーザーまたは役員）かつ（勤怠管理権限または管理職）
        if (((this.editCondition.empCd !== this.authority.loginEmpCd) || (this.authority.empTypeCd === Const.Emptype.EXECTIVE))　&& (this.authority.roleManager || this.authority.roleWorkingHoursAdmin)) {

            //定期申請作成中
            //定期申請承認待ち
            //定期申請承認済み
            if (this.editCondition.requestStatus === Const.TrainPassStatus.MAKING
                || this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL
                || this.editCondition.requestStatus === Const.TrainPassStatus.APPROVED
            ) {
                this.showRejectbtn = true;
            }
        }

        //勤怠管理権限者
        if (this.authority.roleWorkingHoursAdmin) {

            //勤務表　未登録または承認済
            if (
                this.editCondition.workingStatus === null ||
                this.editCondition.workingStatus === Const.MonthlyStatus.UNREGISTERED ||
                this.editCondition.workingStatus === Const.MonthlyStatus.APPROVED ||
                this.editCondition.workingStatus === Const.MonthlyStatus.CLOSING
            ) {
                //定期申請　作成中　承認待
                if (this.editCondition.requestStatus === Const.TrainPassStatus.MAKING
                    || this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {
                    //承認ボタン表示
                    this.showApprovalbtn = true;
                }

                //定期申請　承認済み
                if (this.editCondition.requestStatus === Const.TrainPassStatus.APPROVED) {
                    this.showApprovalbtn = true;
                    this.showCloseMonthly = true;                
                }

                //定期申請　締済
                if (this.editCondition.requestStatus === Const.TrainPassStatus.CLOSING) {
                    this.showCancelClose = true;
                }
            }
        } 

        //＜＞ログインユーザーかつ（勤怠管理権限または管理職または現場リーダーまたは担当営業）
        if (this.editCondition.empCd !== this.authority.loginEmpCd && (this.authority.roleManager || this.authority.roleLeader || this.authority.roleSales || this.authority.roleWorkingHoursAdmin)) {

            //承認待ち
            if (this.editCondition.requestStatus === Const.TrainPassStatus.MAKING) {
                this.showConfirmbtn = true;
            }
            //承認待ち
            if (this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {
                this.showConfirmbtn = true;
            }
            //承認済み
            if (this.editCondition.requestStatus === Const.TrainPassStatus.APPROVED) {
                this.showConfirmbtn = true;
            }

        }

        //決裁理由
        if (this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {
            if (this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL
                || this.editCondition.requestStatus === Const.TrainPassStatus.REMAND
                || this.editCondition.requestStatus === Const.TrainPassStatus.APPROVED) {
                this.showDecisionRemarks = true;
            }
        } else {
            if (this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL
                || this.editCondition.requestStatus === Const.TrainPassStatus.REMAND
                || this.editCondition.requestStatus === Const.TrainPassStatus.APPROVED) {
                if (this.editCondition.decisionRemarks) {
                    this.showDecisionRemarks = true;
                }
            }
        }
    }
    //#endregion

    //#region　画面項目の活性制御
    private displayDisableContorol() {
        //処理前にすべて非活性状態にする
        this.disableSavebtn         = true;
        this.disableCancelbtn       = true;
        this.disableConfirmbtn      = true;
        this.disableApprovalbtn     = true;
        this.disableRejectbtn       = true;
        this.disableCloseMonthly    = true;
        this.disableCancelClose     = true;

        //(勤務表　＜＞未登録かつ＜＞承認済みかつ＜＞締済)または、勤怠管理権限
        if((this.editCondition.workingStatus && this.editCondition.workingStatus !== Const.MonthlyStatus.CLOSING) || this.authority.roleWorkingHoursAdmin)
        {

            //ログインユーザーまたは勤怠管理権限または管理職
            if (this.editCondition.empCd === this.authority.loginEmpCd || this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {
                if (this.editCondition.requestStatus === Const.TrainPassStatus.UNREGISTERED) {
                    this.disableSavebtn = false;
                }
                if (this.editCondition.requestStatus === Const.TrainPassStatus.MAKING) {
                    this.disableSavebtn = false;
                    this.disableApprovalbtn = false;
                }
                if (this.editCondition.requestStatus === Const.TrainPassStatus.REMAND) {
                    this.disableSavebtn = false;
                }
                if (this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {
                    this.disableCancelbtn = false;
                }
            }

            //(＜＞ログインユーザーまたは役員)かつ（勤怠管理権限または管理職）
            if (((this.editCondition.empCd !== this.authority.loginEmpCd) || (this.authority.empTypeCd === Const.Emptype.EXECTIVE)) && (this.authority.roleManager || this.authority.roleWorkingHoursAdmin)) {
                if (this.editCondition.requestStatus === Const.TrainPassStatus.MAKING) {
                    this.disableRejectbtn = false;
                }

                if (this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {
                    this.disableApprovalbtn = false;
                    this.disableRejectbtn = false;
                }
                if (this.editCondition.requestStatus === Const.TrainPassStatus.APPROVED) {
                    this.disableApprovalbtn = false;
                    this.disableRejectbtn = false;
                    if (this.authority.roleWorkingHoursAdmin) {
                        this.disableCloseMonthly = false;
                    }
                }
                if (this.editCondition.requestStatus === Const.TrainPassStatus.CLOSING) {
                    if (this.authority.roleWorkingHoursAdmin) {
                        this.disableCancelClose = false;
                    }
                }
            }

            //＜＞ログインユーザーかつ（勤怠管理権限または管理職または現場リーダーまたは担当営業）
            if (this.editCondition.empCd !== this.authority.loginEmpCd && (this.authority.roleManager || this.authority.roleLeader || this.authority.roleSales || this.authority.roleWorkingHoursAdmin)) {

                if (this.editCondition.requestStatus === Const.TrainPassStatus.MAKING) {
                    this.disableConfirmbtn = false;
                }
                if (this.editCondition.requestStatus === Const.TrainPassStatus.AWAITING_APPROVAL) {
                    this.disableConfirmbtn = false;
                }
                if (this.editCondition.requestStatus === Const.TrainPassStatus.APPROVED) {
                    this.disableConfirmbtn = false;
                }

            }

        }

    }
    //#endregion

    //#region 子コンポーネントの戻り値を設定する
    //乗車駅１
    updateTextStart1(newText: string) {
        this.editCondition.startStation1 = newText;
    }
    updateCdStart1(newCd: string) {
        this.editCondition.startStation1Cd = newCd;
    }
    //下車駅１
    updateTextEnd1(newText: string) {
        this.editCondition.endStation1 = newText;
    }
    updateCdEnd1(newCd: string) {
        this.editCondition.endStation1Cd = newCd;
    }
    //経由駅１
    updateTextTransit1(newText: string) {
        this.editCondition.transitStation1 = newText;
    }
    updateCdTransit1(newCd: string) {
        this.editCondition.transitStation1Cd = newCd;
    }
    //乗車駅２
    updateTextStart2(newText: string) {
        this.editCondition.startStation2 = newText;
    }
    updateCdStart2(newCd: string) {
        this.editCondition.startStation2Cd = newCd;
    }
    //下車駅２
    updateTextEnd2(newText: string) {
        this.editCondition.endStation2 = newText;
    }
    updateCdEnd2(newCd: string) {
        this.editCondition.endStation2Cd = newCd;
    }
    //経由駅２
    updateTextTransit2(newText: string) {
        this.editCondition.transitStation2 = newText;
    }
    updateCdTransit2(newCd: string) {
        this.editCondition.transitStation2Cd = newCd;
    }
    //乗車駅３
    updateTextStart3(newText: string) {
        this.editCondition.startStation3 = newText;
    }
    updateCdStart3(newCd: string) {
        this.editCondition.startStation3Cd = newCd;
    }
    //下車駅３
    updateTextEnd3(newText: string) {
        this.editCondition.endStation3 = newText;
    }
    updateCdEnd3(newCd: string) {
        this.editCondition.endStation3Cd = newCd;
    }
    //経由駅３
    updateTextTransit3(newText: string) {
        this.editCondition.transitStation3 = newText;
    }
    updateCdTransit3(newCd: string) {
        this.editCondition.transitStation3Cd = newCd;
    }
    //#endregion

    //#region 駅名入力チェック（検索ボタン）

    //Params="no"：経路の番号
    private async isValidForSearchRoute(no: number): Promise<boolean> {

        //対象の駅名と駅コードを取得
        let startStationNm =    ( this.editCondition[`startStation${no}` as keyof TrainPassData]     as string )
        let startStationCd =    ( this.editCondition[`startStation${no}Cd` as keyof TrainPassData]   as string )
        let endStationNm =      ( this.editCondition[`endStation${no}` as keyof TrainPassData]       as string )
        let endStationCd =      ( this.editCondition[`endStation${no}Cd` as keyof TrainPassData]     as string )
        let transitStationNm =  ( this.editCondition[`transitStation${no}` as keyof TrainPassData]   as string )
        let transitStationCd =  ( this.editCondition[`transitStation${no}Cd` as keyof TrainPassData] as string )

        //駅名未入力チェック
        if (!this.isEmptyStationText(startStationNm, endStationNm)) {
            return false;
        };

        //駅名入力済かつ駅未選択の場合は検索し、駅を取得する
        if (!startStationCd && startStationNm) {
            //乗車駅
            if (!await this.chekSearchStationResult(no, startStationNm, '乗車駅')) {
                return false;
            }
        }

        if (!endStationCd && endStationNm) {
            //下車駅
            if (!await this.chekSearchStationResult(no, endStationNm, '下車駅')) {
                return false;
            }
        }

        if (!transitStationCd && transitStationNm) {
            //経由駅
            if (!await this.chekSearchStationResult(no, transitStationNm, '経由駅')) {
                return false;
            }
        }

        return true;
    }


    //#region 駅取得チェック
    private async chekSearchStationResult(no: number, stationNm: string, stationType: string): Promise<boolean> {

        const stationInfo = await search1stStation(stationNm, 0, this.getFirstWorkday(this.editCondition.ym));

        //エラー発生の検証
        if (this.openAPImessage(stationInfo.message)) {
            return false;
        }
        else if (!stationInfo.cd) {
            //駅の検索結果が取得できなかった場合、エラーメッセージを表示
            this.errorMessage(StringUtil.stringFormat(MsgConst.EKITAN.ERROR_003, stationType));

            return false;
        };

        //取得した駅情報を設定
        switch (stationType) {
            case '乗車駅':
                (this.editCondition[`startStation${no}` as keyof TrainPassData] as string) = stationInfo.text;
                (this.editCondition[`startStation${no}Cd` as keyof TrainPassData] as string) = stationInfo.cd;
                break;
            case '下車駅':
                (this.editCondition[`endStation${no}` as keyof TrainPassData] as string) = stationInfo.text;
                (this.editCondition[`endStation${no}Cd` as keyof TrainPassData] as string) = stationInfo.cd;
                break;
            case '経由駅':
                (this.editCondition[`transitStation${no}` as keyof TrainPassData] as string) = stationInfo.text;
                (this.editCondition[`transitStation${no}Cd` as keyof TrainPassData] as string) = stationInfo.cd;
                break;
            default:
        }
        return true;
    }
    //#endregion

    //#region 乗車駅・下車駅未入力チェック
    private isEmptyStationText(startStation: string, endStation: string): boolean {

        if (!startStation || !endStation) {
            this.messageClear();

            this.errorMessage(MsgConst.EKITAN.ERROR_004);
            return false;
        }

        return true
    }
    //#endregion

    //#endregion

    //#region ダイアログイベント
    private dialogEvent(reply: string) {
        this.avoidMultipost(async () => {
            if (reply == 'yes') {
                //はいが押された場合
                switch (this.eventNm) {
                    case 'edit':
                        this.edit()
                        break
                    case 'cancel':
                        this.cancel()
                        break
                    case 'confirm':
                        this.confirm()
                        break
                    case 'approval':
                        this.approval()
                        break
                    case 'reject':
                        this.reject()
                        break
                    case 'closeMonthly':
                        this.closeMonthly()
                        break
                    case 'cancelClosing':
                        this.cancelClosing()
                        break
                    case 'changePurchaseFlg':
                        this.clearRoute2()
                        this.clearRoute3()
                        break
                    case 'clickClearRoute2' :
                        this.clearRoute2()
                        this.clearRoute3()
                        break
                    case 'clickClearRoute3' :
                        this.clearRoute3()
                        break
                    case 'changeSameLastMonthFlg':
                        this.getLastMonth()
                        break
                    case 'changeSameLastFlg':
                        this.getLastMonthRoute()
                        break
                    case 'checkEdit':
                        this.checkEdit()
                        break
                    default:
                        break
                }
            } else {
                //いいえが押された場合
                switch (this.eventNm) {
                    case 'changePurchaseFlg':
                        this.editCondition.trainPassPurchaseFlg = false;
                        break
                    case 'clickClearRoute2':
                        this.passRoute2 = true;
                        this.addPassRoute2 = true;
                        break
                    case 'clickClearRoute3':
                        this.passRoute3 = true;
                        this.addPassRoute3 = true;
                        break
                    case 'changeSameLastMonthFlg':
                        this.editCondition.sameLastMonthFlg = false;
                        break
                    case 'changeSameLastFlg':
                        this.editCondition.sameLastRouteFlg = false;
                        break
                    default:
                        break
                }
            }
            //ダイアログを閉じる
            this.dialog = false
            this.showDecisionRemarksDialog = false
            this.eventNm = ''
        })
    }
	//#endregion

    //#region 定期申請情報　取得
    private async getTrainPassData() {
        try {
            const data = {
                SearchCondition: this.searchCondition
            }

            const response = await this.$axios.post('api/TrainPassApplication/Get', data)

            //webLogicのレスポンスにメッセージがある場合は表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (response.data.messageData.errFlg) {

                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            }

            //権限
            this.authority = response.data.authority

            //画面項目
            this.editCondition = response.data.editCondition
            //ログ
            this.logs = response.data.logList

            //活性制御
            this.displayDisableContorol()
            //表示制御
            this.displayShowControl()
            //ガイダンスを表示する
            this.getGuidance(this.editCondition.requestStatus)
            //登録経路を選択する
            Promise.all([this.selectRoute(1), this.selectRoute(2), this.selectRoute(3)]);
            //画面上部へスクロール
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch (e) {
            console.log(e.message)
        }
    }
	//#endregion

    //#region　定期申請情報 登録
    private async edit() {

        //駅名・駅コードに検索時の値を設定
        if (this.editCondition.passKey1) {
            this.editCondition.startStation1 = this.lastStartStation1.text;
            this.editCondition.startStation1Cd = this.lastStartStation1.cd;
            this.editCondition.endStation1 = this.lastEndStation1.text;
            this.editCondition.endStation1Cd = this.lastEndStation1.cd;
            this.editCondition.transitStation1 = this.lastTransitStation1.text;
            this.editCondition.transitStation1Cd = this.lastTransitStation1.cd;
        }
        if (this.editCondition.passKey2) {
            this.editCondition.startStation2 = this.lastStartStation2.text;
            this.editCondition.startStation2Cd = this.lastStartStation2.cd;
            this.editCondition.endStation2 = this.lastEndStation2.text;
            this.editCondition.endStation2Cd = this.lastEndStation2.cd;
            this.editCondition.transitStation2 = this.lastTransitStation2.text;
            this.editCondition.transitStation2Cd = this.lastTransitStation2.cd;
        }
        if (this.editCondition.passKey3) {

            this.editCondition.startStation3 = this.lastStartStation3.text;
            this.editCondition.startStation3Cd = this.lastStartStation3.cd;
            this.editCondition.endStation3 = this.lastEndStation3.text;
            this.editCondition.endStation3Cd = this.lastEndStation3.cd;
            this.editCondition.transitStation3 = this.lastTransitStation3.text;
            this.editCondition.transitStation3Cd = this.lastTransitStation3.cd;
        }

        try {
            const data = {
                EditCondition: this.editCondition,
            }

            this.disableAllFooterBtn();
            const response = await this.$axios.post('api/TrainPassApplication/Edit', data)
            this.restoreAllFooterBtn();

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (!response.data.messageData.errFlg) {
                    //画面を初期化し再度読み込み
                    this.initialize()
                    this.getTrainPassData()
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }
                return
            }
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.requestStatus)

        } catch (e) {
            console.log(e.message)
        } finally {
        }
    }
    
    //#endregion

    //#region　定期申請情報 確認
    private async confirm() {
        try {
            this.disableAllFooterBtn();

            const data = {
                EditCondition: this.editCondition,
            }
            const response = await this.$axios.post('api/TrainPassApplication/Confirm', data)
            this.restoreAllFooterBtn();

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (!response.data.messageData.errFlg) {

                    //画面を初期化し再度読み込み
                    this.initialize()
                    this.getTrainPassData()
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }
                return
            }
            //ガイダンスを表示する
            this.getGuidance(this.editCondition.requestStatus)

        } catch (e) {
            console.log(e.message)
        } finally {
        }
    }
    //#endregion

    //#region 定期申請情報　承認
    private async approval() {
        try {

            const data = {
                EditCondition: this.editCondition,
            }
            this.disableAllFooterBtn();
            const response = await this.$axios.post('api/TrainPassApplication/Approval', data)
            this.restoreAllFooterBtn();

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (!response.data.messageData.errFlg) {

                    //画面を初期化し再度読み込み
                    this.initialize()
                    this.getTrainPassData()
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })

                }
                return
            }
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.requestStatus)

        } catch (e) {
            console.log(e.message)
        } finally {
        }
    }
    //#endregion

    //#region　定期申請情報　否認
    private async reject() {
        try {

            const data = {
                EditCondition: this.editCondition,
            }
            this.disableAllFooterBtn();
            const response = await this.$axios.post('api/TrainPassApplication/Reject', data)
            this.restoreAllFooterBtn();

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (!response.data.messageData.errFlg) {

                    //画面を初期化し再度読み込み
                    this.initialize()
                    this.getTrainPassData()
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }
                return
            }
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.requestStatus)

        } catch (e) {
            console.log(e.message)
        } finally {
        }
    }
    //#endregion

    //#region 定期申請情報　取消
    private async cancel() {
        try {
            const data = {
                EditCondition: this.editCondition,
            }
            this.disableAllFooterBtn();
            const response = await this.$axios.post('api/TrainPassApplication/Cancel', data)
            this.restoreAllFooterBtn();

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (!response.data.messageData.errFlg) {

                    //画面を初期化し再度読み込み
                    this.initialize()
                    this.getTrainPassData()
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }
                return
            }
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.requestStatus)

        } catch (e) {
            console.log(e.message)
        } finally {
        }
    }
	//#endregion

    //#region 定期申請情報　締め
    private async closeMonthly() {
        try {

            const data = {
                EditCondition: this.editCondition,
            }

            this.disableAllFooterBtn();
            const response = await this.$axios.post('api/TrainPassApplication/CloseMonthly', data)
            this.restoreAllFooterBtn();

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (!response.data.messageData.errFlg) {

                    //画面を初期化し再度読み込み
                    this.initialize()
                    this.getTrainPassData()
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }
                return
            }
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.requestStatus)

        } catch (e) {
            console.log(e.message)
        } finally {
        }
    }
    //#endregion

    //#region　定期申請情報 締め解除
    private async cancelClosing() {
        try {

            const data = {
                EditCondition: this.editCondition,
            }

            this.disableAllFooterBtn();
            const response = await this.$axios.post('api/TrainPassApplication/CancelClosing', data)
            this.restoreAllFooterBtn();

            //メッセージがある場合表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (!response.data.messageData.errFlg) {

                    //画面を初期化し再度読み込み
                    this.initialize()
                    this.getTrainPassData()
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                }
                return
            }
            //ガイダンスを表示する
            this.getGuidance(response.data.editCondition.requestStatus)

        } catch (e) {
            console.log(e.message)
        } finally {
        }
    }
    //#endregion

    //#region 経路　検索
    private async searchRoute(no: number) {
        try {
            //対象コントロールを非活性にする
            this.$nextTick(() => {
                this.controlManager.disableControl(this.saveBtn);
                this.controlManager.disableControl(this.sameLastMonthCheck);
                this.controlManager.disableControl(this.sameLastCheck);
                this.controlManager.disableControl(this.purchaseCheck);
                this.controlManager.disableControl(this.ym);
                this.controlManager.disableControl(this[`search${no}Btn` as keyof TrainPassApplicationView]);
            });

            //駅探API検索条件を設定
            let searchCondition = new TrainPassRouteSearchCondition();
            let searchConditionLowest = new TrainPassRouteSearchCondition();
            searchCondition = this.setSearchParamsForTrainPass(no);
            searchConditionLowest = this.setSearchParamsForTrainPass(no);

            //経路を検索する
            [(this[`lowestInfo${no}` as keyof TrainPassApplicationView] as LowestInfo), (this[`routes${no}` as keyof TrainPassApplicationView] as RouteItem[])] = await Promise.all([searchLowestForPass(searchConditionLowest), searchRouteForTrainPass(searchCondition)]);

            if (no === 1) {
                //経路１は最安値経路取得結果を登録情報に設定
                this.editCondition.trainPassMostLowInfo = (this[`lowestInfo${no}` as keyof TrainPassApplicationView] as LowestInfo).passInfo;
                this.editCondition.passPriceMostLow = (this[`lowestInfo${no}` as keyof TrainPassApplicationView] as LowestInfo).price;
            }

            //エラー発生の検証
            if ((this[`routes${no}` as keyof TrainPassApplicationView] as RouteItem[]).length == 0) {
                //経路が存在しない場合
                this.clearRouteContent(no);
                this.errorMessage(MsgConst.EKITAN.ERROR_005);
                return;
            }
            else if (this.openAPImessage(this[`routes${no}` as keyof TrainPassApplicationView][0].message)) {
                //駅探APIエラーの場合
                this.clearRouteContent(no);
                return;
            };

            //検索時の条件を保持する
            this[`lastStartStation${no}` as keyof TrainPassApplicationView].cd      = this.editCondition[`startStation${no}Cd` as keyof TrainPassData];
            this[`lastStartStation${no}` as keyof TrainPassApplicationView].text    = this.editCondition[`startStation${no}` as keyof TrainPassData];
            this[`lastEndStation${no}` as keyof TrainPassApplicationView].cd        = this.editCondition[`endStation${no}Cd` as keyof TrainPassData];
            this[`lastEndStation${no}` as keyof TrainPassApplicationView].text      = this.editCondition[`endStation${no}` as keyof TrainPassData];
            this[`lastTransitStation${no}` as keyof TrainPassApplicationView].cd    = this.editCondition[`transitStation${no}Cd` as keyof TrainPassData];
            this[`lastTransitStation${no}` as keyof TrainPassApplicationView].text  = this.editCondition[`transitStation${no}` as keyof TrainPassData];

        } catch (e) {
            console.log(e.message)
        } finally {
            //対象コントロールの非活性を解除する
            this.$nextTick(() => {
                this.controlManager.restoreControl(this.saveBtn);
                this.controlManager.restoreControl(this.sameLastMonthCheck);
                this.controlManager.restoreControl(this.sameLastCheck);
                this.controlManager.restoreControl(this.purchaseCheck);
                this.controlManager.restoreControl(this.ym);
                this.controlManager.restoreControl(this[`search${no}Btn` as keyof TrainPassApplicationView]);
            });
        }
    }
    //#endregion

    //#region 前月情報を取得する
    private async getLastMonth() {
        try {
            let searchCondition: TrainPassApplicationSearchCondition = new TrainPassApplicationSearchCondition();
            searchCondition.empCd = this.editCondition.empCd;
            searchCondition.ym = StringUtil.changeMonth(this.editCondition.ym, -1);

            const data = {
                SearchCondition: searchCondition
            }

            const response = await this.$axios.post('api/TrainPassApplication/Get', data)

            //webLogicのレスポンスにメッセージがある場合は表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (response.data.messageData.errFlg) {

                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            }

            this.lastMonthInfo = new TrainPassData();
            this.lastMonthInfo = response.data.editCondition;

            this.messageClear();

            if (this.lastMonthInfo.requestStatus === Const.TrainPassStatus.UNREGISTERED) {
                this.showMessage = true
                this.messageType = 'info'
                this.message = MsgConst.TRAINPASS.INFO_002

                //画面上部へスクロール
                window.scrollTo({ top: 0, behavior: 'smooth' })
                return
            }

            //画面へ設定する
            this.setLastMonthValue(true);

            //画面上部へスクロール
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch (e) {
            console.log(e.message)
        } finally {

        }
    }
    //#endregion

    //#region　前月経路情報を取得する
    private async getLastMonthRoute() {
        try {

            let searchCondition: TrainPassApplicationSearchCondition = new TrainPassApplicationSearchCondition();
            searchCondition.empCd = this.editCondition.empCd;
            searchCondition.ym = StringUtil.changeMonth(this.editCondition.ym, -1);

            const data = {
                SearchCondition: searchCondition
            }

            const response = await this.$axios.post('api/TrainPassApplication/Get', data)

            //webLogicのレスポンスにメッセージがある場合は表示
            if (response.data.messageData.messageList.length > 0) {
                this.showMessage = true
                this.message = response.data.messageData.messageList[0]
                response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                if (response.data.messageData.errFlg) {

                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            }

            this.lastMonthInfo = new TrainPassData();
            this.lastMonthInfo = response.data.editCondition;

            this.messageClear();

            if (this.lastMonthInfo.requestStatus === Const.TrainPassStatus.UNREGISTERED) {
                this.showMessage = true
                this.messageType = 'info'
                this.message = MsgConst.TRAINPASS.INFO_002

                //画面上部へスクロール
                window.scrollTo({ top: 0, behavior: 'smooth' })
                return
            }

            //画面へ設定する
            this.setLastMonthRouteValue();

            //画面上部へスクロール
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch (e) {
            console.log(e.message)
        } finally {

        }
    }
    //#endregion

    //#region 前月情報を画面へ設定する
    private setLastMonthValue(ifChktrainPassPurchase: boolean) {
        if (ifChktrainPassPurchase) {
            this.editCondition.trainPassPurchaseFlg = this.lastMonthInfo.trainPassPurchaseFlg;
        }

        this.editCondition.passKey1             = this.lastMonthInfo.passKey1            ;
        this.editCondition.passPrice1           = this.lastMonthInfo.passPrice1          ;
        this.editCondition.startStation1        = this.lastMonthInfo.startStation1       ;
        this.editCondition.endStation1          = this.lastMonthInfo.endStation1         ;
        this.editCondition.transitStation1      = this.lastMonthInfo.transitStation1     ;
        this.editCondition.startStation1Cd      = this.lastMonthInfo.startStation1Cd     ;
        this.editCondition.endStation1Cd        = this.lastMonthInfo.endStation1Cd       ;
        this.editCondition.transitStation1Cd    = this.lastMonthInfo.transitStation1Cd   ;
        this.editCondition.trainPassInfo1       = this.lastMonthInfo.trainPassInfo1      ;
        this.editCondition.passPriceMostLow     = this.lastMonthInfo.passPriceMostLow    ;
        this.editCondition.trainPassMostLowInfo = this.lastMonthInfo.trainPassMostLowInfo;


        if (!this.lastMonthInfo.trainPassPurchaseFlg) {

            //経路2登録済の場合は経路２も表示する
            if (this.lastMonthInfo.passKey2) {

                this.addPassRoute2 = true;
                this.passRoute2 = true;

                this.editCondition.passKey2 = this.lastMonthInfo.passKey2;
                this.editCondition.passPrice2 = this.lastMonthInfo.passPrice2;
                this.editCondition.startStation2 = this.lastMonthInfo.startStation2;
                this.editCondition.endStation2 = this.lastMonthInfo.endStation2;
                this.editCondition.transitStation2 = this.lastMonthInfo.transitStation2;
                this.editCondition.startStation2Cd = this.lastMonthInfo.startStation2Cd;
                this.editCondition.endStation2Cd = this.lastMonthInfo.endStation2Cd;
                this.editCondition.transitStation2Cd = this.lastMonthInfo.transitStation2Cd;
                this.editCondition.trainPassInfo2 = this.lastMonthInfo.trainPassInfo2;

                //経路3登録済の場合は経路３も登録する
                if (this.lastMonthInfo.passKey3) {

                    this.addPassRoute3 = true;
                    this.passRoute3 = true;

                    this.editCondition.passKey3 = this.lastMonthInfo.passKey3;
                    this.editCondition.passPrice3 = this.lastMonthInfo.passPrice3;
                    this.editCondition.startStation3 = this.lastMonthInfo.startStation3;
                    this.editCondition.endStation3 = this.lastMonthInfo.endStation3;
                    this.editCondition.transitStation3 = this.lastMonthInfo.transitStation3;
                    this.editCondition.startStation3Cd = this.lastMonthInfo.startStation3Cd;
                    this.editCondition.endStation3Cd = this.lastMonthInfo.endStation3Cd;
                    this.editCondition.transitStation3Cd = this.lastMonthInfo.transitStation3Cd;
                    this.editCondition.trainPassInfo3 = this.lastMonthInfo.trainPassInfo3;
                } else {
                    this.clearRoute3();
                }
            } else {
                this.clearRoute2();
                this.clearRoute3();
            }
        } else {
            this.clearRoute2();
            this.clearRoute3();
        }

        //経路を検索し、選択
        Promise.all([this.selectRoute(1), this.selectRoute(2), this.selectRoute(3)]);
    }
    //#endregion

    //#region 前月情報を画面へ設定する
    private setLastMonthRouteValue() {

        this.editCondition.passKey1 = this.lastMonthInfo.passKey1;
        this.editCondition.passPrice1 = this.lastMonthInfo.passPrice1;
        this.editCondition.startStation1 = this.lastMonthInfo.startStation1;
        this.editCondition.endStation1 = this.lastMonthInfo.endStation1;
        this.editCondition.transitStation1 = this.lastMonthInfo.transitStation1;
        this.editCondition.startStation1Cd = this.lastMonthInfo.startStation1Cd;
        this.editCondition.endStation1Cd = this.lastMonthInfo.endStation1Cd;
        this.editCondition.transitStation1Cd = this.lastMonthInfo.transitStation1Cd;
        this.editCondition.trainPassInfo1 = this.lastMonthInfo.trainPassInfo1;
        this.editCondition.passPriceMostLow = this.lastMonthInfo.passPriceMostLow;
        this.editCondition.trainPassMostLowInfo = this.lastMonthInfo.trainPassMostLowInfo;


        if (!this.lastMonthInfo.trainPassPurchaseFlg && !this.editCondition.trainPassPurchaseFlg) {

            //経路2登録済の場合は経路２も表示する
            if (this.lastMonthInfo.passKey2) {

                this.addPassRoute2 = true;
                this.passRoute2 = true;

                this.editCondition.passKey2 = this.lastMonthInfo.passKey2;
                this.editCondition.passPrice2 = this.lastMonthInfo.passPrice2;
                this.editCondition.startStation2 = this.lastMonthInfo.startStation2;
                this.editCondition.endStation2 = this.lastMonthInfo.endStation2;
                this.editCondition.transitStation2 = this.lastMonthInfo.transitStation2;
                this.editCondition.startStation2Cd = this.lastMonthInfo.startStation2Cd;
                this.editCondition.endStation2Cd = this.lastMonthInfo.endStation2Cd;
                this.editCondition.transitStation2Cd = this.lastMonthInfo.transitStation2Cd;
                this.editCondition.trainPassInfo2 = this.lastMonthInfo.trainPassInfo2;

                //経路3登録済の場合は経路３も登録する
                if (this.lastMonthInfo.passKey3) {

                    this.addPassRoute3 = true;
                    this.passRoute3 = true;

                    this.editCondition.passKey3 = this.lastMonthInfo.passKey3;
                    this.editCondition.passPrice3 = this.lastMonthInfo.passPrice3;
                    this.editCondition.startStation3 = this.lastMonthInfo.startStation3;
                    this.editCondition.endStation3 = this.lastMonthInfo.endStation3;
                    this.editCondition.transitStation3 = this.lastMonthInfo.transitStation3;
                    this.editCondition.startStation3Cd = this.lastMonthInfo.startStation3Cd;
                    this.editCondition.endStation3Cd = this.lastMonthInfo.endStation3Cd;
                    this.editCondition.transitStation3Cd = this.lastMonthInfo.transitStation3Cd;
                    this.editCondition.trainPassInfo3 = this.lastMonthInfo.trainPassInfo3;
                } else {
                    this.clearRoute3();
                }
            } else {
                this.clearRoute2();
                this.clearRoute3();
            }
        } else {
            this.clearRoute2();
            this.clearRoute3();
        }

        //経路を検索し、選択
        Promise.all([this.selectRoute(1), this.selectRoute(2), this.selectRoute(3)]);
    }
    //#endregion

    //#region dialog
    //はい・いいえダイアログ
    private openDialog(title: string, msg: string) {
        this.title = title
        this.dialogMsg = msg
        this.dialog = true
    }
    //確認ダイアログ
    private openConfirmationDialog(title: string, msg: string) {
        this.title = title
        this.dialogMsg = msg
        this.confirmationDialog = true
    }
    //#endregion

    //#region エラーメッセージ
    private errorMessage(message: string) {
        this.showMessage = true
        this.messageType = 'error'
        this.message = message
        //画面上部へスクロール
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
	//#endregion

    //#region 数値を三桁カンマで表示する
    private formatNumber(value: number): string {
        return StringUtil.formatNumber(value.toString());
    }
    //#endregion

	//#region メッセージクリア
	private messageClear() {
		this.message = ''
		this.showMessage = false
	}
	//#endregion

    //#region　経路を検索し、登録情報を選択する
    private async selectRoute(no :number) {

        if (this.editCondition[`passKey${no}` as keyof TrainPassData]) {
        //経路が登録されている場合、検索・選択処理を開始

            switch (no) {
                //経路２・３が登録済の場合、画面に表示
                case 2:
                    this.addPassRoute2 = true;
                    this.passRoute2 = true;
                    break;
                case 3:
                    this.addPassRoute3 = true;
                    this.passRoute3 = true;
                    break;
                default:
                    break;
            }
            //経路検索処理
            await this.searchRoute(no);

            //経路情報から該当する経路を選択する
            for (const i of this[`routes${no}` as keyof TrainPassApplicationView]) {
                if ((i.passInfo === this.editCondition[`trainPassInfo${no}` as keyof TrainPassData])
                    || (i.commuterRegistKey === this.editCondition[`passKey${no}` as keyof TrainPassData])
                ) {
                    //選択
                    i.check = true;

                    //最安値かどうか
                    (this[`notLowest${no}Flg` as keyof TrainPassApplicationView] as boolean) = this.isNotLowestRoute(no);
                    
                    break;
                }
            }
        }
    }
    //#endregion

    //#region 経路１を破棄
    private clearRoute1() {

        this.routes1 = [];


        this.editCondition.passKey1 = '';
        this.editCondition.passPrice1 = '';
        this.editCondition.startStation1 = '';
        this.editCondition.endStation1 = '';
        this.editCondition.transitStation1 = '';
        this.editCondition.startStation1Cd = '';
        this.editCondition.endStation1Cd = '';
        this.editCondition.transitStation1Cd = '';
        this.editCondition.trainPassInfo1 = '';


        this.lastStartStation1.cd = '';
        this.lastStartStation1.text = '';
        this.lastEndStation1.cd = '';
        this.lastEndStation1.text = '';
        this.lastTransitStation1.cd = '';
        this.lastTransitStation1.text = '';
    }
    //#endregion

    //#region 経路２を破棄
    private clearRoute2() {
        this.addPassRoute2 = false;
        this.passRoute2 = false;
        this.routes2 = [];
        

        this.editCondition.passKey2             = '' ;
        this.editCondition.passPrice2           = '' ;
        this.editCondition.startStation2        = '' ;
        this.editCondition.endStation2          = '' ;
        this.editCondition.transitStation2      = '' ;
        this.editCondition.startStation2Cd      = '' ;
        this.editCondition.endStation2Cd        = '' ;
        this.editCondition.transitStation2Cd    = '' ;
        this.editCondition.trainPassInfo2       = '';


        this.lastStartStation2.cd        =  '';
        this.lastStartStation2.text      =  '';
        this.lastEndStation2.cd          =  '';
        this.lastEndStation2.text        =  '';
        this.lastTransitStation2.cd      =  '';
        this.lastTransitStation2.text    =  '';
    }
    //#endregion

    //#region　経路３を破棄
    private clearRoute3() {
        this.addPassRoute3 = false;
        this.passRoute3 = false;
        this.routes3 = [];
        this.editCondition.passKey3             = '' ;
        this.editCondition.passPrice3           = '' ;
        this.editCondition.startStation3        = '' ;
        this.editCondition.endStation3          = '' ;
        this.editCondition.transitStation3      = '' ;
        this.editCondition.startStation3Cd      = '' ;
        this.editCondition.endStation3Cd        = '' ;
        this.editCondition.transitStation3Cd    = '' ;
        this.editCondition.trainPassInfo3       = '' ;


        this.lastStartStation3.cd               = '';
        this.lastStartStation3.text             = '';
        this.lastEndStation3.cd                 = '';
        this.lastEndStation3.text               = '';
        this.lastTransitStation3.cd             = '';
        this.lastTransitStation3.text           = '';
    }
    //#endregion

    //#region 月初勤務日を取得する
    private getFirstWorkday(yyyymm :string) {
        const year = parseInt(yyyymm.substring(0, 4), 10);
        const month = parseInt(yyyymm.substring(4, 6), 10) - 1; // JavaScriptの月は0から始まる
        let date = new Date(year, month, 1);

        while (date.getDay() === 0 /** 日曜日*/ || date.getDay() === 6　/** 土曜日*/ || holiday_jp.isHoliday(date)　/**祝日*/) {
            date.setDate(date.getDate() + 1);
        }

        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        return `${yyyy}${mm}${dd}`;
    }
    //#endregion

    //#region　申請ステータスコードからテキストに変換する
    private formatStatusText(status: string): string {
        switch (status) {
            case Const.TrainPassStatus.UNREGISTERED:
                return '未申請';
            case Const.TrainPassStatus.MAKING:
                return '作成中';
            case Const.TrainPassStatus.REMAND:
                return '差戻';
            case Const.TrainPassStatus.AWAITING_APPROVAL:
                return '承認待ち';
            case Const.TrainPassStatus.APPROVED:
                return '承認済';
            case Const.TrainPassStatus.CLOSING:
                return '締済';
            default:
                return '';
        }
    }
    //#endregion

    //#region 経路を初期化
    clearRouteContent(no: number) {
        //経路１
        if (no === 1) {
            this.routes1 = [];
            this.editCondition.passPrice1 = '';
            this.editCondition.passKey1 = '';
            this.editCondition.trainPassInfo1 = '';
            this.editCondition.trainPassMostLowInfo = '';
            this.notLowest1Flg = false;
        }
        //経路２
        else if (no === 2) {
            this.routes2 = [];
            this.editCondition.passPrice2 = '';
            this.editCondition.passKey2 = '';
            this.editCondition.trainPassInfo2 = '';
            this.notLowest2Flg = false;
        }
        //経路３
        else if (no === 3) {
            this.routes3 = [];
            this.editCondition.passPrice3 = '';
            this.editCondition.passKey3 = '';
            this.editCondition.trainPassInfo3 = '';
            this.notLowest3Flg = false;
        }
    }
    //#endregion

    //#region 駅探API検索条件を設定する
    private setSearchParamsForTrainPass(no: number): TrainPassRouteSearchCondition{

        let searchCondition = new TrainPassRouteSearchCondition();

        searchCondition.startStationCd = this.editCondition[`startStation${no}Cd` as keyof TrainPassData] as string;
        searchCondition.endStationCd = this.editCondition[`endStation${no}Cd` as keyof TrainPassData] as string;
        searchCondition.transitStationCd = this.editCondition[`transitStation${no}Cd` as keyof TrainPassData] as string;
        searchCondition.targetDate = this.getFirstWorkday(this.editCondition.ym);
        searchCondition.targetTime = '0900';

        return searchCondition
    };
    //#endregion

    //#region 選択中経路が最安値かどうか判定する
    @Watch('editCondition.passPrice1', { immediate: true, deep: true })
    check() {
        this.notLowest1Flg = this.isNotLowestRoute(1);
    }
    @Watch('editCondition.passPrice2', { immediate: true, deep: true })
    check2() {
        this.notLowest2Flg = this.isNotLowestRoute(2);
    }
    @Watch('editCondition.passPrice3', { immediate: true, deep: true })
    check3() {
        this.notLowest3Flg = this.isNotLowestRoute(3);
    }

    private isNotLowestRoute(no: number): boolean {
        if (this.editCondition[`passKey${no}` as keyof TrainPassData]
            && this[`lowestInfo${no}` as keyof TrainPassApplicationView]?.price
            && this.editCondition[`passPrice${no}` as keyof TrainPassData]) {
            if (this.editCondition[`passPrice${no}` as keyof TrainPassData] != (this[`lowestInfo${no}` as keyof TrainPassApplicationView] as LowestInfo)?.price) {
                return true
            }
            return false
        }

        return false;
    }
    //#endregion

    //#region  登録時チェック
    private async checkEdit() {
        if (this.passRoute2 && !this.editCondition.passKey2) {

            this.clearRoute2();
        }

        if (this.passRoute3 && !this.editCondition.passKey3) {

            this.clearRoute3();

        }

        //経路２が未入力だが経路３が入力されている場合、経路３を経路２とする
        if ( !this.editCondition.passKey2 && this.editCondition.passKey3) {

            this.editCondition.passKey2             = this.editCondition.passKey3           ;
            this.editCondition.passPrice2           = this.editCondition.passPrice3         ;
            this.editCondition.startStation2        = this.editCondition.startStation3      ;
            this.editCondition.endStation2          = this.editCondition.endStation3        ;
            this.editCondition.transitStation2      = this.editCondition.transitStation3    ;
            this.editCondition.startStation2Cd      = this.editCondition.startStation3Cd    ;
            this.editCondition.endStation2Cd        = this.editCondition.endStation3Cd      ;
            this.editCondition.transitStation2Cd    = this.editCondition.transitStation3Cd  ;
            this.editCondition.trainPassInfo2 = this.editCondition.trainPassInfo3;

            this.lastStartStation2.cd        =  this.lastStartStation3.cd    ; 
            this.lastStartStation2.text      =  this.lastStartStation3.text  ; 
            this.lastEndStation2.cd          =  this.lastEndStation3.cd      ; 
            this.lastEndStation2.text        =  this.lastEndStation3.text    ; 
            this.lastTransitStation2.cd      =  this.lastTransitStation3.cd  ; 
            this.lastTransitStation2.text    =  this.lastTransitStation3.text; 

            this.clearRoute3();
        }


        //登録処理
        this.edit();
    }
    //#endregion

    //#region  駅探検索中エラーの検証
    private openAPImessage(message: string|null) : boolean{

        if (message) {
            this.errorMessage(message);
            //画面上部へスクロール
            window.scrollTo({ top: 0, behavior: 'smooth' })
            return true
        }
        return false
    }
    //#endregion

    //#region すべてのフッターボタンを一時非活性状態にする
    private disableAllFooterBtn() {

        this.$nextTick(() => {
            this.controlManager.disableControl(this.saveBtn);
            this.controlManager.disableControl(this.cancelBtn);
            this.controlManager.disableControl(this.confirmBtn);
            this.controlManager.disableControl(this.approvalBtn);
            this.controlManager.disableControl(this.rejectBtn);
            this.controlManager.disableControl(this.closeMonthlyBtn);
            this.controlManager.disableControl(this.cancelCloseBtn);
            this.controlManager.disableControl(this.ym);

        });
    }
    //#endregion

    //#region　すべてのフッターボタンの一時非活性状態を解除する
    private restoreAllFooterBtn() {
        this.$nextTick(() => {
            this.controlManager.restoreControl(this.saveBtn);
            this.controlManager.restoreControl(this.cancelBtn);
            this.controlManager.restoreControl(this.confirmBtn);
            this.controlManager.restoreControl(this.approvalBtn);
            this.controlManager.restoreControl(this.rejectBtn);
            this.controlManager.restoreControl(this.closeMonthlyBtn);
            this.controlManager.restoreControl(this.cancelCloseBtn);
            this.controlManager.restoreControl(this.ym);
        });

        this.displayDisableContorol();
    }
    //#endregion

    //#region 年月文字列　を変換する
    @Watch('editCondition.ym', { immediate: true, deep: true })
    private formatDateString(dateStr: string) {
        this.ymStr = StringUtil.formatDateString(dateStr);
    }
    //#endregion
    //#endregion
}
